import styled from 'styled-components';
import { Image, Button, Gap, Heading } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useNewUserState } from '../context/useNewUserContext';

const SplashElement = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

const SubHeaderElement = styled.div`
  font-style: italic;
  font-size: 18px;
  color: green;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const DescriptionElement = styled.div`
  color: ${({ theme }) => theme.vars.newColor.darkGS1};
  font-size: 14px;
  margin-top: 10px;
`;

export function NewUserSuccessPage() {
  const { push } = useHistory();
  const { t } = useTranslation();
  const { createdUser } = useNewUserState();
  return (
    <SplashElement>
      <Image src={'/images/new-user-success-splash.svg'} height={300} />
      <Heading variation="h1">{t('newUser.successPage.heading')}</Heading>
      <SubHeaderElement>{t('newUser.successPage.subHeading', createdUser)}</SubHeaderElement>
      <DescriptionElement>{t('newUser.successPage.message1')}</DescriptionElement>
      <DescriptionElement>{t('newUser.successPage.message2')}</DescriptionElement>
      <Gap top={40} />
      <Button variation="primary" onClick={() => push('/user-management/users')}>
        {t('newUser.successPage.buttonText')}
      </Button>
    </SplashElement>
  );
}
